<style scoped>
#job {
	padding: 0px;
	min-height: 100%;
}
#outlined{
	outline-style: solid;
	outline-width: thin;
	color: #C4C4C4;
}
</style>

<template>
	<div id="job">
		<v-container fluid class="pa-4">
			<v-alert type="error" v-if="errormsg != ''">{{
				errormsg
			}}</v-alert>

			<v-expansion-panels v-model="panels" multiple popout>
				<v-expansion-panel>
					<v-expansion-panel-header>
						
						<div>
							<span class="mr-1" style="color: #CA66D2"> Job Information</span> 
							<!-- <v-btn  text x-small depressed color="#CA66D2" @click.stop="click_on_info_edit" :disabled="edit_on_jobinfo">
								<v-icon small>edit</v-icon>
								<edit_icon color="#CA66D2" /> 
							</v-btn> -->
						</div>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-row v-if="!loading" no-gutters>
							<v-col cols="12" md="6">

								<span class="px-2">Job information</span>

								<v-row no-gutters>
									<v-col cols="12" class="mb-2 pl-2 pr-1">
										<v-text-field
											hide-details
											:readonly="!edit_on_jobinfo"
											
											label="Job number"
											v-model="job.code"
										/>
									</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col cols="12" class="mb-2 pl-2 pr-1">
										<v-text-field
											hide-details
											:readonly="!edit_on_jobinfo"
											label="Job short"
											v-model="job.short"
										/>
									</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col cols="12" class="mb-2 pl-2 pr-1">
										<v-text-field
											hide-details
											:readonly="!edit_on_jobinfo"
											label="Job title"
											v-model="job.description"
										/>
									</v-col>
								</v-row>
								<v-row no-gutters>
									<!-- <v-col cols="3">
										<div class="text-right pr-4 pt-5"> Job type: </div>
									</v-col> -->
									<v-col cols="12" class="mb-2 pl-2 pr-1">
										<v-select
											label="Job type"
											v-model="job.job_type.id"
											:readonly="!edit_on_jobinfo"
											:items="job_types"
											item-text="desc"
											item-value="id"
											hide-details
											
										>
											<template v-slot:selection="{ item, index }">
												<span>{{ item.desc }}</span>
											</template>
										</v-select>
									</v-col>
								</v-row>

								<v-row no-gutters>
									<v-col cols="12" class="mb-2 pl-2 pr-1">
										<v-select
											label="Job status"
											v-model="job.status.id"
											:readonly="!edit_on_jobinfo"
											:items="statusses"
											item-text="desc"
											item-value="id"
											hide-details
											
										>
											<template v-slot:selection="{ item, index }">
												<span>{{ item.desc }}</span>
											</template>
										</v-select>
									</v-col>
								</v-row>

								<v-row no-gutters>
									<v-col cols="12" class="mb-2 pl-2 pr-1">
										<v-text-field
											hide-details
											:readonly="!edit_on_jobinfo"
											label="Keywords"
											v-model="job.keywords"
										/>
									</v-col>
								</v-row>
							</v-col>

							<v-col cols="12" md="6"	>
								<span class="pl-2">Team</span>
								<v-row v-if="job.acc_exec" no-gutters>
									<v-col cols="12" class="mb-2 pl-2 pr-1">
										<v-text-field
											hide-details
											:readonly="!edit_on_jobinfo"
											label="Acc executive"
											v-model="job.acc_exec.name"
										/>
									</v-col>
								</v-row>
								<v-row v-if = "job.acc_dir" no-gutters>
									<v-col  cols="12" class="mb-2 pl-2 pr-1">
										<v-text-field 
											hide-details
											:readonly="!edit_on_jobinfo"
											label="Acc director"
											v-model="job.acc_dir.name"
										/>
									</v-col>
								</v-row>

								<span class="pl-2">Client</span>
								<v-row no-gutters>
									<v-col cols="12" class="mb-2 pl-2 pr-1">
										<v-text-field
											hide-details
											:readonly="!edit_on_jobinfo"
											label="Client"
											v-model="job.client.name"
										/>
									</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col cols="12" class="mb-2 pl-2 pr-1">
										<v-text-field
											hide-details
											:readonly="!edit_on_jobinfo"
											label="Division"
											v-model="job.division.name"
										/>
									</v-col>
								</v-row>
								<v-row v-if = "job.contact" no-gutters>
									<v-col cols="12" class="mb-2 pl-2 pr-1">
										<v-text-field
											hide-details
											:readonly="true"
											label="Contact"
											v-model="job.contact.name"
										/>
									</v-col>
								</v-row>
							</v-col>
						</v-row>

						
						<v-row v-if="!loading" no-gutters>
							<v-col v-if = "job.opened !==null || job.deadline !== null" cols="12" md="6" class="mb-2 pl-2 pr-1">
								<div id="outlined" > <!--class="mx-3" -->
									<div class="px-1 grey--text" v-if = "job.opened !== null">Opened</div>
									<div class="px-2 grey--text" v-if = "job.opened !== null">{{job.opened| moment("dddd, MMMM DD YYYY")}}</div>
									<div class="px-1 grey--text " v-if = "job.deadline">Deadline</div>
									<div class="px-2 grey--text" v-if = "job.deadline !== null">{{job.deadline|moment("dddd, MMMM DD YYYY hh:mm a")}}</div>
								</div>
							</v-col>

							<v-col cols="12" md="6">
								<v-row no-gutters>
									<v-col cols="12" :sm="job.modified_on !== null ? 6:12" md="12" :lg="job.modified_on !== null ? 6:12" class="mb-2 pl-2 pr-1">
										<div id="outlined"><!--class="mx-3" -->
											<div>Created</div>
											<div>{{job.created_by.name}}</div>
											<div>{{job.created_on|moment("dddd, MMMM DD YYYY hh:mm a")}}</div>	
										</div>
									</v-col>
									<v-col v-if = "job.modified_on !== null" cols="12" sm="6" md="12" lg="6" class="mb-2 pl-2 pr-1">
										<div id="outlined"> <!--class="mx-3" -->
											<div>Modified</div>
											<div>{{job.modified_by.name}}</div>								
											<div>{{job.modified_on|moment("dddd, MMMM DD YYYY hh:mm a")}}</div>
										</div>
									</v-col>
								</v-row>


								<v-btn @click="click_on_info_cancel" :disabled="!edit_on_jobinfo" v-show="edit_on_jobinfo" clas="ma-2"> Cancel</v-btn>

								<v-btn @click="click_on_info_save" :disabled="!edit_on_jobinfo" v-show="edit_on_jobinfo" class="ma-2">Save</v-btn>
							</v-col>
																			
						</v-row>
						<v-row v-if="loading" no-gutters>
							<v-col cols="12">
								<v-skeleton-loader
									type="list-item-avatar-two-line"
									width="100%"
								></v-skeleton-loader>
							</v-col>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
						
				<!-- Move job details here from top panel  -->
				<v-expansion-panel v-if = "job.details">
					<v-expansion-panel-header>
						<span style="color: #CA66D2"> Job Details</span> 
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<!-- <span class="pl-2">Job Details</span> -->

						<v-row no-gutters>
							<v-col cols="12" md="6" :key="job_detail.id" v-for="job_detail in job.details" class="mb-2 pl-2 pr-1">
							
								<!-- character-->
								<v-text-field
									hide-details
									readonly
									:label="job_detail.det_label"
									v-model="job_detail.det_value"
									v-if="job_detail.data_type === 21" 
								/>
								<!-- date-->
								<!-- need to find a way to disable this -->
								<jb-date-picker 
									:label="job_detail.det_label"
									:disabled = "!edit_on_jobinfo"
									v-model="job_detail.det_value"
									v-if="job_detail.data_type === 23"
								/>
								<!-- datetime-->
								<v-text-field
									hide-details
									readonly
									:label="job_detail.det_label"
									v-model="job_detail.det_value"
									v-if="job_detail.data_type === 1000"
								/>
								<!-- time-->
								<v-text-field
									hide-details
									readonly
									:label="job_detail.det_label"
									v-model="job_detail.det_value"
									v-if="job_detail.data_type === 6"
								/>
							</v-col>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>

				<v-expansion-panel>
					<v-expansion-panel-header>
						<span style="color: #CA66D2"> Specification</span> 
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-card-text>
							<div v-if="job.specification">{{job.specification.text}}</div>	
						</v-card-text>
					</v-expansion-panel-content>
				</v-expansion-panel>

				<v-expansion-panel>
					<v-expansion-panel-header>
						<span style="color: #CA66D2"> Notes</span> 
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						Here we put something...
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-container>
	</div>
</template>

<script>
import { metaMixin } from "@/mixins/jobs/metaMixin";
import { dateMixin } from "@/mixins/misc/dateMixin";
// import edit_icon from "@/components/icons/edit_icon";
import DatePicker from "@/components/controls/jbdate";
import moment from 'moment';

export default {
	mixins: [ metaMixin, dateMixin ],
	data() {
		return {
			loading: false,
			added_crumb: false,
			errormsg: '',
			panels: [ 0 ],
			job: {
				id: 0,
				code: '',
				short: '',
				deadline: null,
				job_type: { name: '' },
				status: {name:''},
				client: { name: '' },
				division: {name: ''},
				contact:{name:''},
				acc_exec:{name:''},
				acc_dir:{name:''},
				created_on: null,
				created_by: { name: '' },
				modified_by: {name: ''},
				modified_on: null,
				details:[
					{det_label:'',det_value:''}
				],
				specification:{},

			},
			edit_on_jobinfo: false,
			

		}
	},

	components: {
		// edit_icon,
		'jb-date-picker': DatePicker
		// none yet
	},
	created() {
		this.load_meta_data()
		this.load(this.$route.params.id)
	},

	methods: {
		load(job_id) {
			let self = this; // make sure we can access this inside of our promisses
			this.loading = true;

			axios
				.get("/api/jobs/" + job_id, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log("got data");

						self.job = json.data;
						
						if (self.job.details !== null) {
							self.job.details.forEach(function(detail){
								if (detail.data_type==23){
									// date
									detail.det_value = self.ymd_to_date(detail.det_value);
								};
								if (detail.data_type==6){
									// time
									detail.det_value = moment(detail.det_value,'hhmmss').format('hh:mm a');
								};
								if (detail.data_type==1000){
									// date-time
									detail.det_value = moment(detail.det_value,'hhmmss').format('DD MMM YYYY hh:mm a');
								};

							});
						};


						// we add this the first time around
						if (!self.added_crumb) {
							self.added_crumb = true;

							self.$store.commit("push_breadcrumb", {
								exact: true,
								text: self.job.code,
								to: self.$route.path
							});
						};

						// self.loaded_settings = { ...self.list };
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading = false;
				});
		},

		click_on_info_edit(){
			if (!this.edit_on_jobinfo){
				if(!this.panels.includes(0)){
					this.panels.push(0)
				}
				// this.edit_on_jobinfo = true  we'll enable this once we're ready to do job edit
			}


		},
		click_on_info_save(){
			if (this.edit_on_jobinfo){
				this.edit_on_jobinfo = false
				//need to add save and reload
			}
		},
		click_on_info_cancel(){
			if(this.edit_on_jobinfo){
				this.edit_on_jobinfo = false
				// need to add code to cancel the change and reload
			}
		}

	}
}	
</script>